import { useEffect, useCallback } from 'react'
import { useRouter } from 'next/router'
import { useUI } from '@corratech/pylot-ui/context'

export const UseZohoHideShow = () => {
    const router = useRouter()
    const { displaySidebar } = useUI()

    const zohoExcludedPaths = ['/checkout', '/order-success']

    const isBundleCustomizationPage =
        router?.query?.option && router?.query?.option === 'customize'

    const checkZohoSalesIQReady = useCallback((callback) => {
        const zohoInterval = setInterval(() => {
            if (
                window.$zoho &&
                window.$zoho.salesiq &&
                window.$zoho.salesiq?.floatbutton
            ) {
                clearInterval(zohoInterval)
                callback()
            }
        }, 400)

        setTimeout(() => {
            clearInterval(zohoInterval)
        }, 12000)
    }, [])

    const showHideZoho = useCallback(() => {
        if (
            displaySidebar ||
            isBundleCustomizationPage ||
            zohoExcludedPaths.includes(router.pathname ?? '')
        ) {
            window.$zoho.salesiq.floatbutton.visible('hide')
            window.$zoho.salesiq.floatwindow.visible('hide')
        } else {
            window.$zoho.salesiq.floatbutton.visible('show')
        }
    }, [
        displaySidebar,
        router.pathname,
        router.asPath,
        isBundleCustomizationPage
    ])

    const handleButtonClick = useCallback(() => {
        if (window.$zoho && window.$zoho.salesiq) {
            window.$zoho.salesiq.floatbutton.visible('show')
            window.$zoho.salesiq.floatwindow.visible('show')
        }
    }, [])

    useEffect(() => {
        const attachEventListener = () => {
            const button = document.querySelector('.openChat button')

            if (button) {
                button.addEventListener('click', handleButtonClick)
            }

            return () => {
                if (button) {
                    button.removeEventListener('click', handleButtonClick)
                }
            }
        }

        // Attach event listener when component mounts
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.addedNodes.length) {
                    attachEventListener()
                }
            })
        })

        observer.observe(document.body, { childList: true, subtree: true })

        // Handle route changes and reattach event listener
        const handleRouteChange = () => {
            attachEventListener()
            checkZohoSalesIQReady(showHideZoho)
        }

        router.events.on('routeChangeComplete', handleRouteChange)

        return () => {
            router.events.off('routeChangeComplete', handleRouteChange)
            observer.disconnect()
        }
    }, [handleButtonClick, checkZohoSalesIQReady, showHideZoho, router.events])

    // Initial setup
    useEffect(() => {
        checkZohoSalesIQReady(showHideZoho)
    }, [checkZohoSalesIQReady, showHideZoho])

    return null
}
